/**
 * Pulls in the assessment node data and mounts react application.
 */
import humps from 'lodash-humps';
import React from 'react';
import ReactDOM from 'react-dom';
import Assessment from './Assessment';

require('isomorphic-fetch');

(() => {
  /* global drupalSettings */
  const nodeId = drupalSettings.assessments.nid;
  let initialState;
  const timestampNow = Math.floor(Date.now() / 1000);
  if (sessionStorage[`assessmentData-${nodeId}`]) {
    const timestampLast = sessionStorage[`assessmentTimestamp-${nodeId}`];
    if ((timestampNow - timestampLast) > 2700) {
      sessionStorage.removeItem(`assessmentData-${nodeId}`);
      sessionStorage.removeItem(`assessmentTimestamp-${nodeId}`);
    } else {
      initialState = JSON.parse(sessionStorage[`assessmentData-${nodeId}`]);
    }
  }
  fetch(`/api/assessments/node/${nodeId}?_format=json`, {
    credentials: 'same-origin',
  })
  .then(response => response.json())
  .then((assessmentData) => {
    ReactDOM.render(
      <Assessment
        assessmentData={humps(assessmentData)}
        initialState={initialState}
        nodeId={nodeId}
      />,
      document.getElementById('assessment-app'),
    );
  })
  .catch((ex) => {
    console.log('parsing failed', ex);
  });
})();



// WEBPACK FOOTER //
// js/src/assessment/App.js